import { useCustomBackground } from "@/Contexts/CustomBackground";
import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import Icon from "@/icons";
import { ImageDisplay } from "../ImageDisplay";

export default function SettingsCustomBg() {
    const { settings, setSettings } = useCustomBackground();
    const [isOpen, setIsOpen] = useState(false);
    const [imageSrc,] = useState("");

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async () => {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("type", "customBackground");
                const res = await fetch("__SITE_BASE__/api/v1/upload", {
                    method: "POST",
                    body: formData
                });

                const data = await res.json();
                if (res.ok) {
                    document.getElementById('preview')?.classList.remove('hidden');
                    setSettings({ ...settings, url: data.url });
                    setIsOpen(false);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <>
            <div className="mt-8 justify-between w-full items-center flex">
                <label className="text-lg font-medium text-white">Enable Custom Background</label>
                <div
                    className={`relative inline-flex items-center cursor-pointer`}
                    onClick={() => setSettings({ ...settings, enabled: !settings.enabled })}
                >
                    <input
                        type="checkbox"
                        className="sr-only"
                        checked={settings.enabled}
                        onChange={() => setSettings({ ...settings, enabled: !settings.enabled })}
                    />
                    <div
                        className={`block w-14 h-8 rounded-full ${settings.enabled ? 'bg-brand-green' : 'bg-brand-profile'}`}
                    >
                        <div
                            className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${settings.enabled ? 'translate-x-6' : 'translate-x-0'}`}
                        />
                    </div>
                </div>
            </div>

            <div className="flex flex-col mt-4">
                <p className="text-gray-400">Set a custom background for your dashboard</p>
                <div className="mt-4 flex flex-col">
                    <label className="block text-sm font-medium text-gray-700">Background Image</label>

                    <div className="relative w-full h-96 mt-4 items-center cursor-pointer">
                        <div className="flex items-center justify-center w-full h-full bg-brand-darkest border-dashed border-2 border-brand-green rounded-lg overflow-hidden" onClick={() => setIsOpen(true)}>
                            {settings.url && <img src={settings.url} className="absolute inset-0 object-cover w-full h-full rounded" alt="Preview Image" />}
                            {!settings.url && <Icon name="picture" size="32" color="white" />}
                        </div>
                        <label className="text-sm text-gray-400 mt-2 items-end justify-end">
                            1920x1080px recommended
                        </label>
                        {settings.url && (
                            <ImageDisplay url={settings.url}>
                                <button className="absolute right-2 bg-brand-dark text-white rounded-lg p-1">
                                    <Icon name="fullscreen" size="20" />
                                </button>
                            </ImageDisplay>
                        )}
                    </div>
                </div>
            </div>

            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                    <DialogHeader className="items-center justify-center">
                        <DialogTitle>
                            Upload a new banner
                        </DialogTitle>
                    </DialogHeader>
                    <div className="flex items-center justify-center gap-4">
                        <div className="flex flex-col items-center w-full h-full justify-center gap-1">
                            <div className="relative w-full h-44 mt-4 items-center cursor-pointer" onClick={() => document.getElementById('image')?.click()}>
                                <div className="flex items-center justify-center w-full h-full bg-brand-darkest border-dashed border-2 border-brand-green rounded-lg overflow-hidden">
                                    <img id="preview" src={imageSrc} className="absolute inset-0 object-cover w-full h-full hidden rounded" alt="Preview Image" />
                                    <Icon name="picture" size="32" color="white" />
                                    <input type="file" id="image" className="hidden" accept="image/png, image/jpeg, image/gif" onChange={(event) => {
                                        handleImageChange(event);
                                        setIsOpen(false);
                                    }} />
                                </div>
                                <div className="absolute bottom-[-10px] right-[-10px] bg-gradient-to-br from-blue-500/50 to-blue-600/50 rounded-full w-8 h-8 flex items-center justify-center">
                                    <Icon name="plus" size="24" color="white" />
                                </div>
                            </div>
                            <span className="text-sm text-gray-400 mt-2">
                                (Max. 5MB)
                            </span>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}